import React, { useState, useEffect } from "react";
import {
    Grid,
    Container,
    TableCell,
    TableRow,
    Table,
    TableHead,
    TableBody,
    Card,
    TextareaAutosize,
    Button,
    TextField,
    Alert,
    Box,
    Avatar,
    Stack,
    CircularProgress
} from "@mui/material";
import { useNavigate, useParams } from 'react-router';
import { axiosFetch } from '../../../../utils/AxiosFetch';
import Select from 'react-select';
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";
import './Form.css';
import { useDispatch } from "react-redux";
import { CustomizedSnackbar } from "../../../../shared";
import { Link } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DoneIcon from '@mui/icons-material/Done';
import ViewComments from "./ViewComments";
// import { Stack } from "immutable";
import John from '../../../../assets/john.png';
import ReviewForm from "./ReviewForm";
import { TimeConversion } from "../../../../utils/TimeConversion";
import Voice from '../../../../assets/Aggregate-Intelligence-The-VOICE-Value-System.pdf';
import { Dialog, DialogContent, DialogContentText, DialogActions } from '@mui/material'


let traingList = [];
let voiceList = [];
let newList = [];

const Form = () => {

    var userDetails =
        localStorage.getItem("argus_user") !== null
            ? localStorage.getItem("argus_user")
            : null;
    var loggedUserId =
        userDetails !== null && JSON.parse(userDetails).userid !== null
            ? JSON.parse(userDetails).userid
            : "";
    let Velocity_sum = 0;
    let OwnerShip_sum = 0;
    let Intellectual_sum = 0;
    let customer_centricity_sum = 0;
    let Excellence_sum = 0;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    const [insights, setInsights] = useState("");
    const [insightsError, setInsightsError] = useState(false);
    const [scores, setScores] = useState([]);
    const [okrList, setOkrList] = useState([]);
    const [trainingList, setTrainingList] = useState([]);
    const [voiceQuestList, setVoiceQuestList] = useState([]);
    const [profileDetail, setProfileDetail] = useState(null);
    const [voiceFeedback, setVoiceFeedback] = useState([]);
    const [okrFeedback, setOkrFeedback] = useState([]);
    const [trainingFeedback, setTrainingFeedback] = useState({ trainingScore: [], externalTrainingScore: [] });
    const [employeeId, setEmployeeId] = useState("");
    const [reportingPersonId, setReportingPersonId] = useState("");
    const [isOpenCommentPopup, setIsOpenToggleCommentPopup] = useState(false);
    const [okrScore, setOkrScore] = useState(0);
    const [voiceScore, setVoiceScore] = useState(0);
    const [trainingScore, setTrainingScore] = useState(0);
    const [isError, setIsError] = useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);

    const [avg_OkrScore, setAvg_OkrScore] = useState(0);
    const [avg_TrainingScore, setAvg_TrainingScore] = useState(0);
    const [avg_VoiceScore, setAvg_VoiceScore] = useState(0);

    const [commentList, setCommentsList] = useState([]);
    const [isCompleted, setIsCompleted] = useState(false);
    const [isOpenConfirmPopup, setIsOpenConfirmPopup] = useState(false);

    const [variablePayList, setVariablePayList] = useState([]);
    const [scorelist, setScoreList] = useState(null);

    const [isEnableInsightBtn, setIsEnableInsightBtn] = useState(false);
    const [formStatusId, setFormStatusId] = useState("");

    const [empLoader, setEmpLoader] = useState(false);
    const [okrLoader, setOkrLoader] = useState(false);
    const [voiceLoader, setVoiceLoader] = useState(false);
    const [trainingLoader, settrainingLoader] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(false);

    const handleClose = () => {
        navigate('/performance');

    }

    const handleCloseDiloag = () => {
        setOpenDialog(false);
    };
    // okr - 40
    // training -20
    // voice -40

    const calculateAvgScore_okr = (okrObj, value) => {


        if (okrObj !== undefined && value !== undefined) {
            let index = okrList.findIndex(list => list.okrId == okrObj.okrId)
            newList[index].score = parseInt(value);
            const sum = newList.reduce((accumulator, object) => {
                return accumulator + object.score;
            }, 0);
            let avg = sum / okrList.length;
            let score = avg * 4;
            let overall_percentage = score.toFixed(2);
            setAvg_OkrScore(overall_percentage);
        }
        else if (okrList.length !== 0) {
            const sum = okrList.reduce((accumulator, object) => {
                return accumulator + object.score;
            }, 0);
            let avg = sum / okrList.length;
            let score = avg * 4;
            let overall_percentage = score.toFixed(2);
            setAvg_OkrScore(overall_percentage);
        }
        else {
            let defaultScore = 0.0;
            setAvg_OkrScore(defaultScore.toFixed(2));
        }


        // let result = ((avg_okr + score) / count * (40 / 100));
        // setAvg_OkrScore((result).toFixed(2));
    };

    const calculateAvgScore_training = (selectedObj, value) => {



        if ((trainingList && trainingList.trainings !== undefined && trainingList.trainings.length !== 0) || (trainingList && trainingList.externalTrainings !== undefined && trainingList.externalTrainings.length !== 0)) {

            const result = [...trainingList.trainings, ...trainingList.externalTrainings];


            if (selectedObj !== undefined && value !== undefined) {

                let index = result.findIndex(list => list.id == selectedObj.id)
                traingList[index].trainingScore = parseInt(value);
                const sum = traingList.reduce((accumulator, object) => {
                    return accumulator + object.trainingScore;

                }, 0);
                let avg = sum / result.length;
                let score = avg * 2;
                let overall_percentage = score.toFixed(2);

                setAvg_TrainingScore(overall_percentage);
            }
            else if (result.length !== 0) {
                const sum = result.reduce((accumulator, object) => {
                    return accumulator + object.trainingScore;
                }, 0);
                let avg = sum / result.length;
                let score = avg * 2;
                let overall_percentage = score.toFixed(2);

                setAvg_TrainingScore(overall_percentage);
            }
            else {
                let defaultScore = 0.0;
                setAvg_TrainingScore(defaultScore.toFixed(2));
            }

        }

    };

    const SubArraySum = (arr, n) => {
        let result = 0, temp = 0;

        // Pick starting point
        for (let i = 0; i < n; i++) {
            // Pick ending point
            temp = 0;
            //for (let j = i; j < n; j++) {
            // sum subarray between current
            // starting and ending points
            temp += arr[i].questions.length;
            result += temp;
            //}
        }
        return result;
    }

    const calculateAvgScore_voice = (selectedObj, value, voiceType) => {


        if (selectedObj !== undefined && value !== undefined) {
            let voiceTypeIndex = voiceList.findIndex(voice => voice.voiceType === voiceType);
            let index = voiceList[voiceTypeIndex].questions.findIndex(ques => ques.id === selectedObj.questionId)
            voiceList[voiceTypeIndex].questions[index].score = parseInt(value);

            voiceList.forEach(voice => {
                if (voice.voiceType === 'Velocity') {
                    Velocity_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === 'Ownership') {
                    OwnerShip_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === 'Intellectual Integrity') {
                    Intellectual_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === "Customer Centricity") {
                    customer_centricity_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === 'Excellence') {
                    Excellence_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
            });
        }
        else if (voiceQuestList.length !== 0) {
            voiceQuestList.forEach(voice => {
                if (voice.voiceType === 'Velocity') {
                    Velocity_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === 'Ownership') {
                    OwnerShip_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === 'Intellectual Integrity') {
                    Intellectual_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === "Customer Centricity") {
                    customer_centricity_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
                else if (voice.voiceType === 'Excellence') {
                    Excellence_sum = voice.questions.reduce((accumulator, object) => {
                        return accumulator + object.score
                    }, 0);
                }
            });

        }
        const overall_sum = Velocity_sum + OwnerShip_sum + Intellectual_sum + customer_centricity_sum + Excellence_sum;
        let totalVoiceQuestions = voiceList ? SubArraySum(voiceList, voiceList.length) : 0
        let avg = totalVoiceQuestions > 0 ? overall_sum / totalVoiceQuestions : 0;
        let score = avg * 4;
        let overall_percentage = score.toFixed(2);
        setAvg_VoiceScore(overall_percentage);

    }


    const handleSubmit = () => {

        if (voiceQuestList.length !== 0) {
            voiceQuestList.forEach(voice => {
                if (voice.voiceType === 'Velocity') {

                    if (voice.questions.some(ques => ques.score === null)) {
                        dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Voice Section'));
                        setIsError(true);
                        return false;
                    }
                    else {
                        setIsError(false);
                    }

                }
                if (voice.voiceType === 'Ownership') {

                    if (voice.questions.some(ques => ques.score === null)) {
                        dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Voice Section'));
                        setIsError(true);
                        return false;

                    }
                    else {
                        setIsError(false);
                    }
                }
                if (voice.voiceType === 'Intellectual Integrity') {

                    if (voice.questions.some(ques => ques.score === null)) {
                        dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Voice Section'));
                        setIsError(true);
                        return false;
                    }
                    else {
                        setIsError(false);
                    }
                }
                if (voice.voiceType === "Customer Centricity") {

                    if (voice.questions.some(ques => ques.score === null)) {
                        dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Voice Section'));
                        setIsError(true);
                        return false;
                    }
                    else {
                        setIsError(false);
                    }
                }
                if (voice.voiceType === 'Excellence') {

                    if (voice.questions.some(ques => ques.score === null)) {
                        dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Voice Section'));
                        setIsError(true);
                        return false;
                    }
                    else {
                        setIsError(false);
                    }
                }
            })
        }
        if (insights === null || insights === "") {
            dispatch(SnackbarActions(true, 'warning', 'Please fill out Insights'));
            setIsError(true);
            return false;
        }
        else {
            setIsError(false);
        }
        if (okrList.length !== 0 && okrList.some(okr => okr.score === null)) {
            dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in OKR Section'));
            setIsError(true);
            return false;
        }
        else {
            setIsError(false);
        }
        if(trainingList&& trainingList.trainings.length !== 0){
            if(trainingList.trainings.some(training => training.trainingScore === null)){
                dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Training Section'));
                setIsError(true);
                return false;
            }
            else {
                setIsError(false);
            }
        }
        if(trainingList&& trainingList.externalTrainings.length !== 0){
            if(trainingList.externalTrainings.some(training => training.trainingScore === null)){
                dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Training Section'));
                setIsError(true);
                return false;
            }
            else {
                setIsError(false);
            }
        }

        // if (trainingList &&
        //     ((trainingList.trainings.length !== 0 && trainingList.trainings.some(training => training.trainingScore === null))
        //         &&
        //         (trainingList.externalTrainings.length !== 0 && trainingList.externalTrainings.some(training => training.trainingScore === null)))) {
            
        //     dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Training Section'));
        //     setIsError(true);
        //     return false;
        // }
        // else {
        //     setIsError(false);
        // }
        // if (voiceQuestList.map(ques => ques.questions.some(score => score.score === null))) {
        //     dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Voice Section'));
        //     return false;
        // }

        // if (!(okrFeedback.length === okrList && okrList === okrFeedback.filter(okr => okr.hasOwnProperty('score')).length)) {
        //     dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in OKR Details'));
        //     return false;
        // }
        // if (!(trainingFeedback.length === trainingList && trainingList === trainingFeedback.filter(training => training.hasOwnProperty('score')).length)) {
        //     dispatch(SnackbarActions(true, 'warning', 'Please fill out all fields in Training Details'));
        //     return false;
        // }


        if (!isError && okrList.every(okr => okr.score !== null) && trainingList.trainings.every(training => training.trainingScore !== null) && trainingList.externalTrainings.every(training => training.trainingScore !== null) && voiceQuestList.map(ques => ques.questions.every(score => score.score !== null))) {
            setSubmitLoader(true)
            setIsOpenConfirmPopup(true);
            axiosFetch({
                method: "get",
                url: `/Performance/review/${id}`
            })
                .then((res) => {
                    if (res.status === 200) {
                        setSubmitLoader(false)

                        setScoreList(res.data);
                    }
                    else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    }
                    else if (res.status === 401) {
                        navigate('/');
                    }
                })

                .catch(err => {
                    console.error(err);
                })

        }



    };

    const toggleCommentsPopup = (param, id) => {

        if (param === 1) {
            setIsOpenToggleCommentPopup(true);
            loadComments(id);
        }
        else if (param === 2) {
            setIsOpenToggleCommentPopup(false);
        }
    }

    const toggleConfirmPopup = (param, id) => {

        if (param === 1) {
            setIsOpenConfirmPopup(true);

        }
        else if (param === 2) {
            setIsOpenConfirmPopup(false);

        }
    }

    const loadVariablePayLookup = () => {
        axiosFetch({
            method: "get",
            url: "/Lookup/reviewscores"
        })
            .then((res) => {
                if (res.status === 200) {
                    setVariablePayList(res.data);
                }
                // else if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                // }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err => {
                console.error(err);
            })
    };


    const loadComments = (id) => {

        axiosFetch({
            method: "get",
            url: `/Performance/okr/review/comments/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setCommentsList(res.data);
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch((err) => console.error(err));
    }

    const handleOKRFeedback = () => {

        setOkrLoader(true)
        if (okrFeedback.length === 0 && newList.every(okr => okr.score > 0)) {
            dispatch(SnackbarActions(true, 'warning', `Please select (or) update the score/remarks in OKR's/goals`));
            setOkrLoader(false)
            return false;
        }

        axiosFetch({
            method: "post",
            url: "/Performance/okrscore",
            requestConfig: {
                okrScore: okrFeedback
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    setOkrLoader(false);
                    dispatch(SnackbarActions(true, 'success', `Score updated successfully in OKR's/goals`));
                    if (res.data) {
                        loadOkrsData();
                        setOkrFeedback([]);
                    }
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.data === 401) {
                    navigate('/');
                }
            })
            .catch(err => {
                console.error(err);
            })



    }

    const SaveTrainingFeedback = () => {
        settrainingLoader(true);
        if (trainingFeedback.trainingScore.length === 0
            && trainingFeedback.externalTrainingScore.length === 0
            && traingList.every(training => training.trainingScore > 0)
        ) {
            settrainingLoader(false);

            dispatch(SnackbarActions(true, 'warning', `Please select (or) update the score/remarks in Training and Development`));
            return false;
        }
        axiosFetch({
            method: "post",
            url: "/Performance/trainingScore",
            requestConfig: {
                trainingScore: trainingFeedback.trainingScore,
                externalTrainingScore: trainingFeedback.externalTrainingScore
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    settrainingLoader(false);
                    dispatch(SnackbarActions(true, 'success', 'Score updated successfully in Training and Development'));
                    loadTrainingData();
                    setTrainingFeedback({ trainingScore: [], externalTrainingScore: [] });
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    const SaveVoiceFeedback = () => {
        setVoiceLoader(true);

        if (voiceFeedback.length === 0
            && voiceList.some(user => user.questions.some(quest => quest.score > 0))) {
            setVoiceLoader(false);
            dispatch(SnackbarActions(true, 'warning', `Please select (or) update the score/remarks in Performance and Use of VOICE`));
            return false;
        }
        axiosFetch({
            method: "post",
            url: "/Performance/voicescore",
            requestConfig: {
                "voiceScore": voiceFeedback
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    setVoiceLoader(false);

                    dispatch(SnackbarActions(true, 'success', 'Score updated successfully in Performance and Use of VOICE'));
                    if (res.data) {
                        loadVoiceQuestions();
                        setVoiceFeedback([]);

                    }
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }

    const handleInsightsSubmit = () => {
        if (insights === "") {
            setInsightsError(true);
            return false;
        }
        if (insights !== "") {
            setIsEnableInsightBtn(true);
            setEmpLoader(true);
            axiosFetch({
                method: "post",
                url: "/Performance/employeeinsights",
                requestConfig: {
                    "id": parseInt(id),
                    "employeeInsights": insights
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        if (res.data === 'success') {
                            dispatch(SnackbarActions(true, 'success', 'Insights Added, Your review meeting will be scheduled soon!'));
                            setEmpLoader(false);
                            setTimeout(() => {
                                navigate('/performance');
                            }, 2000);
                        }
                    }
                    else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    }
                    else if (res.status === 401) {
                        navigate('/');
                    }
                })
                .catch(err => {
                    console.error(err);
                })

        }
    };

    const loadScoreLookup = () => {
        axiosFetch({
            method: 'get',
            url: '/Lookup/scores'
        })
            .then(res => {
                if (res.status === 200) {
                    setScores(res.data);
                }
                // else if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                // }
                else if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch(err => {
                console.error(err);
            })

    };

    const loadProfileDetails = () => {
        axiosFetch({
            method: "get",
            url: `/Performance/employee/profile/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.result !== null) {
                        setProfileDetail(res.data.result);
                        setReportingPersonId(res.data.result.reportingPersonId);
                        setEmployeeId(res.data.result.id);
                    }

                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }

    const handleChangeOKR = (value, okrObj, action) => {

        let data = [...okrFeedback];


        if (okrFeedback.length !== 0) {
            if (data.filter((okr) => okr.okrId === okrObj.okrId).length !== 0) {
                if (action !== undefined) {
                    let obj = {
                        okrId: okrObj.okrId,
                        [action.name]: parseInt(value.value),
                        id: parseInt(id),
                        employeeId: employeeId,
                        comment: okrObj.remarks !== null ? okrObj.remarks : undefined
                    }
                    data.filter((okr) => okr.okrId === okrObj.okrId)[0].score = parseInt(value.value);
                    calculateAvgScore_okr(obj, parseInt(value.value));
                }
                else {
                    data.filter((okr) => okr.okrId === okrObj.okrId)[0].comment = value.target.value;

                }

            }
            else {
                if (action !== undefined) {
                    let obj = {
                        okrId: okrObj.okrId,
                        [action.name]: parseInt(value.value),
                        id: parseInt(id),
                        employeeId: employeeId,
                        comment: okrObj.remarks !== null ? okrObj.remarks : undefined

                    }
                    data.push(obj)
                    calculateAvgScore_okr(obj, parseInt(value.value));
                }
                else {
                    data.push({
                        okrId: okrObj.okrId,
                        [value.target.name]: value.target.value,
                        id: parseInt(id),
                        employeeId: employeeId,
                        score: okrObj.score !== null ? okrObj.score : undefined
                    })
                }
            }
        }
        else {
            if (action !== undefined) {
                let obj = {
                    okrId: okrObj.okrId,
                    [action.name]: value.value,
                    id: parseInt(id),
                    employeeId: employeeId,
                    comment: okrObj.remarks !== null ? okrObj.remarks : undefined
                }
                data.push(obj)
                calculateAvgScore_okr(obj, value.value);
            }
            else {
                data.push({
                    okrId: okrObj.okrId,
                    [value.target.name]: value.target.value,
                    id: parseInt(id),
                    employeeId: employeeId,
                    score: okrObj.score !== null ? okrObj.score : undefined
                })
            }
        }

        setOkrFeedback(data);

    };

    const handleChangeTraining = (value, trainingObj, action, type) => {


        let data = trainingFeedback;

        if (type === "i") {


            if (trainingFeedback.trainingScore.length !== 0) {

                if (data.trainingScore.filter((obj) => obj.trainingId === trainingObj.id).length !== 0) {
                    if (action !== undefined) {

                        let obj = {
                            id: parseInt(trainingObj.id),
                            [action.name]: parseInt(value.value),
                            employeeId: employeeId,
                            comment: trainingObj.scoreComment
                        }

                        data.trainingScore.filter((obj) => obj.trainingId === trainingObj.id)[0].trainingScore = parseInt(value.value);
                        trainingObj.trainingScore = parseInt(value.value);
                        calculateAvgScore_training(obj, value.value)
                    }
                    else {
                        data.trainingScore.filter((obj) => obj.trainingId === trainingObj.id)[0].comment = value.target.value;
                        trainingObj.comment = value.target.value;
                    }
                }
                else {
                    if (action !== undefined) {
                        let obj = {
                            id: parseInt(trainingObj.id),
                            [action.name]: parseInt(value.value),
                            employeeId: employeeId,
                            comment: trainingObj.scoreComment
                        }
                        data.trainingScore.push(obj)
                        trainingObj.trainingScore = parseInt(value.value);
                        calculateAvgScore_training(obj, value.value)
                    }
                    else {
                        data.trainingScore.push({
                            id: trainingObj.id,
                            [value.target.name]: value.target.value,
                            employeeId: employeeId,
                            score: trainingObj.trainingScore
                        })
                        trainingObj.comment = value.target.value;
                    }
                }

            }

            else if (trainingFeedback.trainingScore.length === 0) {

                if (action !== undefined) {
                    let obj = {
                        id: trainingObj.id,
                        [action.name]: parseInt(value.value),
                        employeeId: employeeId,
                        comment: trainingObj.scoreComment
                    }
                    data.trainingScore.push(obj)
                    trainingObj.trainingScore = parseInt(value.value);
                    calculateAvgScore_training(obj, value.value)
                }
                else {
                    data.trainingScore.push({
                        id: trainingObj.id,
                        [value.target.name]: value.target.value,
                        employeeId: employeeId,
                        score: trainingObj.trainingScore
                    })
                    trainingObj.comment = value.target.value;
                }
            }
        }
        if (type === "x") {

            if (trainingFeedback.externalTrainingScore.length !== 0) {

                if (data.externalTrainingScore.filter((obj) => obj.externalTrainingId === trainingObj.id).length !== 0) {
                    if (action !== undefined) {
                        let obj = {
                            id: parseInt(trainingObj.id),
                            [action.name]: parseInt(value.value),
                            employeeId: employeeId,
                            comment: trainingObj.scoreComment
                        }
                        calculateAvgScore_training(obj, value.value)
                        data.externalTrainingScore.filter((obj) => obj.externalTrainingId === trainingObj.id)[0].trainingScore = parseInt(value.value);
                        trainingObj.trainingScore = parseInt(value.value);
                    }
                    else {
                        data.externalTrainingScore.filter((obj) => obj.externalTrainingId === trainingObj.id)[0].comment = value.target.value;
                        trainingObj.comment = value.target.value;
                    }
                }
                else {
                    if (action !== undefined) {
                        let obj = {
                            id: parseInt(trainingObj.id),
                            [action.name]: parseInt(value.value),
                            employeeId: employeeId,
                            comment: trainingObj.scoreComment
                        }
                        data.externalTrainingScore.push(obj)
                        trainingObj.trainingScore = parseInt(value.value);
                        calculateAvgScore_training(obj, value.value)
                    }
                    else {
                        data.externalTrainingScore.push({
                            id: trainingObj.id,
                            [value.target.name]: value.target.value,
                            employeeId: employeeId,
                            score: trainingObj.trainingScore
                        })
                        trainingObj.comment = value.target.value;
                    }
                }
            }
            else if (type === "x" && trainingFeedback.externalTrainingScore.length === 0) {

                if (action !== undefined) {
                    let obj = {
                        id: trainingObj.id,
                        [action.name]: parseInt(value.value),
                        employeeId: employeeId,
                        comment: trainingObj.scoreComment
                    };
                    data.externalTrainingScore.push(obj)
                    trainingObj.trainingScore = parseInt(value.value);
                    calculateAvgScore_training(obj, value.value)
                }
                else {
                    data.externalTrainingScore.push({
                        id: trainingObj.id,
                        [value.target.name]: value.target.value,
                        employeeId: employeeId,
                        score: trainingObj.trainingScore
                    })
                    trainingObj.comment = value.target.value;
                }
            }
        }



        setTrainingFeedback(data);

    };

    const handleChangeVoice = (value, questionObj, action, voiceType) => {


        let data = [...voiceFeedback];
        if (voiceFeedback.length !== 0) {
            if (data.filter((obj) => obj.questionId === questionObj.id).length !== 0) {
                if (action !== undefined) {
                    let obj = {
                        questionId: questionObj.id,
                        [action.name]: parseInt(value.value),
                        id: parseInt(id),
                        employeeId: employeeId,
                        comment: questionObj.comment !== null ? questionObj.comment : undefined
                    }
                    data.filter((obj) => obj.questionId === questionObj.id)[0].score = parseInt(value.value);
                    calculateAvgScore_voice(obj, value.value, voiceType);
                }
                else {
                    data.filter((obj) => obj.questionId === questionObj.id)[0].comment = value.target.value;
                }
            }
            else {
                if (action !== undefined) {
                    let obj = {
                        questionId: questionObj.id,
                        [action.name]: parseInt(value.value),
                        id: parseInt(id),
                        employeeId: employeeId,
                        comment: questionObj.comment !== null ? questionObj.comment : undefined


                    }
                    data.push(obj)
                    calculateAvgScore_voice(obj, value.value, voiceType);
                }
                else {
                    data.push({
                        questionId: questionObj.id,
                        [value.target.name]: value.target.value,
                        id: parseInt(id),
                        employeeId: employeeId,
                        score: questionObj.score !== null ? questionObj.score : undefined
                    })
                }
            }
        }
        else {
            if (action !== undefined) {
                let obj = {
                    questionId: questionObj.id,
                    [action.name]: parseInt(value.value),
                    id: parseInt(id),
                    employeeId: employeeId,
                    comment: questionObj.comment !== null ? questionObj.comment : undefined
                }
                data.push(obj);
                calculateAvgScore_voice(obj, value.value, voiceType)
            }
            else {
                data.push({
                    questionId: questionObj.id,
                    [value.target.name]: value.target.value,
                    id: parseInt(id),
                    employeeId: employeeId,
                    score: questionObj.score !== null ? questionObj.score : undefined
                })
            }
        }

        setVoiceFeedback(data);
    }

    const handleInsightsChange = (e) => {
        setInsights(e.target.value);
        if (e.target.value === "") {
            setInsightsError(true);
            return false;
        }
        else {
            setInsightsError(false);
        }
    };

    const loadInsights = () => {
        axiosFetch({
            url: `/Performance/employeeinsights/${id}`,
            method: "get"
        })
            .then((res) => {
                if (res.status === 200) {
                    setInsights(res.data.employeeInsight !== null ? res.data.employeeInsight : "");
                    setIsCompleted(res.data.isComplete);
                    setFormStatusId(res.data.statusId);
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate("/");
                }
            })

            .catch(err => {
                console.error(err);
            })
    }

    const loadOkrsData = () => {
        axiosFetch({
            method: "get",
            url: `/Performance/employeeokrs/${id}`
        })
            .then(res => {
                if (res.status === 200) {
                    setOkrList(res.data);
                    newList = res.data;
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    const loadTrainingData = () => {

        axiosFetch({
            method: "get",
            url: `/Performance/employeetrainings/${id}`
        })
            .then(res => {
                if (res.status === 200) {
                    setTrainingList(res.data);
                    if (res.data.trainings.length !== 0) {
                        traingList = [...res.data.trainings]
                    }
                    if (res.data.externalTrainings.length !== 0) {
                        if (res.data.trainings.length > 0) {
                            traingList = [...traingList, ...res.data.externalTrainings];
                        }
                        else {
                            traingList = [...res.data.externalTrainings];
                        }

                    }

                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err => {
                console.error(err);
            })
    };

    const loadVoiceQuestions = () => {
        axiosFetch({
            method: "get",
            url: `/Performance/voicequestions/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setVoiceQuestList(res.data);
                    voiceList = res.data;
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
                else if(res.status === 500){
                    if(res.data === "You are not an authorised user"){
                        dispatch(SnackbarActions(true, "error", "You are not authorized to view this form"));
                        setTimeout(()=>{
                            navigate('/performance');
                        },2000)
                    }
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    const approveTheForm = () => {
        axiosFetch({
            method: 'post',
            url: `/performance/review/approve/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setOpenDialog(false);
                    dispatch(SnackbarActions(true, "success", "Request Approved!"));
                    window.location.reload();
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", `${res.data}`));
                }
                else if (res.status === 401) {
                    window.location.href = '/';
                }

            })
    }

    const handleClickOpenDialog = () => {

        setOpenDialog(true);
    };
    useEffect(() => {


        loadProfileDetails();
        loadScoreLookup();
        loadInsights();
        loadOkrsData();
        loadTrainingData();
        loadVoiceQuestions();
        loadVariablePayLookup();

        window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        calculateAvgScore_okr();
    }, [okrList]);

    useEffect(() => {
        calculateAvgScore_training();
    }, [trainingList]);
    useEffect(() => {
        calculateAvgScore_voice();
    }, [voiceQuestList])


    return (
        <div className="argus-pmp-module">
            <Dialog
                open={openDialog}
                onClose={handleCloseDiloag}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to approve this request?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className='theme-btn cancel-btn'  onClick={handleCloseDiloag}>No</Button>
                    <Button className='theme-btn' autoFocus onClick={approveTheForm}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            {/* <CssBaseline /> */}
            {/* <Grid container spacing={2} sx={{ textAlign: "center", margin: "10px 0" }}>
                <Grid item xs={12}>
                    <img src={logo} alt="Ai Logo" className="logo" />
                </Grid>
            </Grid>
            <Grid container sx={{ backgroundColor: "#fff", marginTop: "20px", marginBottom: "20px", borderRadius: "10px", display: "flex", alignItems: "center" }}>
                <Grid item xs={5}>
                    <img src="https://images.unsplash.com/photo-1543132220-4bf3de6e10ae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" className="ceo-img" alt="John Tilly" />
                </Grid>
                <Grid item xs={7}>
                    <div className="ceo-box">
                        <h2>John Tilly</h2>
                        <small>CEO, Aggregate Intelligence</small>
                        <small>jtilly@aggregateintelligence.com</small>
                        <p>The purpose of the new Performance Management Program (PMP) is to create better clarity and communication between everyone in the company and ensure we are all synchronized on goals and objectives. PMP relates to the future as much as the past. The purpose is to create a real opportunity for you to earn more and learn more at Aggregate Intelligence, and also to help you get more involved and central to the key mission of the company. I want you to feel like you are involved in something interesting, rewarding and fulfilling. If you have any suggestions or comments, always reach out to me.</p>
                        <p className="info-message">Note to the Team Member / Appraisee</p>
                    </div>
                </Grid>
            </Grid> */}
            <div className="note">
                {/* <Container fixed> */}
                <Box sx={{ bgcolor: '#cfe8fc', padding: '25px', borderRadius: "10px", height: "20%", border: "1px solid #abd5ff" }}>
                    <h2 className="header">Note to the Team Member / Appraisee</h2>
                    <p>The purpose of the new Performance Management Program (PMP) is to create better clarity and communication between everyone in the company and ensure we are all synchronized on goals and objectives. PMP relates to the future as much as the past. The purpose is to create a real opportunity for you to earn more and learn more at Aggregate Intelligence, and also to help you get more involved and central to the key mission of the company. I want you to feel like you are involved in something interesting, rewarding and fulfilling. If you have any suggestions or comments, always reach out to me.</p>
                    <div className='fw-bolder user-msg'>
                        <Avatar alt="John Tilly" src={John} />
                        <div className='john-msg'>
                            <strong style={{ color: " #113776" }}>John Tilly, CEO, Aggregate Intelligence</strong><br />
                            <i>jtilly@aggregateintelligence.com</i>
                        </div>
                    </div>
                </Box>
                {/* </Container> */}
            </div>
            {/* <div className="note">
                // <Container fixed>
                    <Box sx={{ bgcolor: '#cfe8fc', padding: '25px', borderRadius: "25px", height: "20%" }}>
                        <h2 className="header">Note to the Team Member / Appraisee</h2>
                        <hr></hr>
                       
                        <div className='fw-bolder user-msg'>
                            <Avatar alt="Remy Sharp" src={John} />
                            <div className='john-msg'>
                                <strong style={{ color: " #4990cd" }}>John Tilly, CEO, Aggregate Intelligence</strong><br />
                                <i>jtilly@aggregateintelligence.com</i>
                            </div>
                        </div>
                    </Box>
                </Container>
            </div>
            <br /> */}
            <div className="note">
                {/* <Container fixed> */}
                <Card className='variable-pay'>
                    <h2 className="fixed-header">Variable Pay Structure at AI</h2>
                    <p className="pmp-para">From July 1, 2022, every employee at AI will now be eligible for Variable Pay. The level of variable pay you can earn depends on performance during the six months prior to the Performance Discussion and based on goals and objectives discussed in your last Performance Discussion. The maximum threshold is set at 8%. The level of variable pay you earn is determined by the scoring system explained below - your line manager will discuss this with you and discuss particular performance metrics to determine the level of variable pay bonus you will receive:</p>
                    <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={6}>
                            <Table className="score-table left-color">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Overall Score</strong></TableCell>
                                        <TableCell sx={{ color: "#113776 !important" }}><strong>Variable Pay%</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {variablePayList.map((vp) => {
                                        return (
                                            <TableRow key={vp.id}>
                                                <TableCell>{vp.overallScore}</TableCell>
                                                <TableCell>{vp.variablePay + "%"}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                    {/* <tr>
                                            <td>{'>'}95</td>
                                            <td>8%</td>
                                        </tr>
                                        <tr>
                                            <td>{'>'}85</td>
                                            <td>7%</td>
                                        </tr>
                                        <tr>
                                            <td>{'>'}75</td>
                                            <td>6%</td>
                                        </tr>
                                        <tr>
                                            <td>{'>'}65</td>
                                            <td>5%</td>
                                        </tr>
                                        <tr>
                                            <td>{'>'}55</td>
                                            <td>4%</td>
                                        </tr>
                                        <tr>
                                            <td>{'>'}45</td>
                                            <td>2%</td>
                                        </tr>
                                        <tr>
                                            <td>{'<'}45</td>
                                            <td>NA</td>
                                        </tr> */}
                                </TableBody>
                            </Table>
                        </Grid>
                        <Grid item xs={6}>
                            <h2 className="pmp-headings" style={{ marginTop: "0" }}>Percentage wise scores</h2>
                            <ul className="okr-goals">
                                <li> <DoneIcon className="tick-icon" /><span>OKRs / Goals - </span><b>40%</b></li>
                                <li><DoneIcon className="tick-icon" /><span>Performance / Use of VOICE - </span><b>40%</b></li>
                                <li><DoneIcon className="tick-icon" /><span>Training and Development - </span><b>20%</b></li>
                            </ul>
                        </Grid>
                    </Grid>
                    <br />
                    <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={6}>
                            <h2 className="pmp-headings">Team Member / Appraisee</h2>
                            <Table className="score-table argus-table left-table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.firstName !== null ? profileDetail.lastName !== null ? profileDetail.firstName + " " + profileDetail.lastName : profileDetail.firstName : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Emp ID</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.employeeCode !== null ? profileDetail.employeeCode : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Department Name / Team Name</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.departmentName !== null ? profileDetail.teamName !== null ? profileDetail.departmentName + "/" + profileDetail.teamName : "-" : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Job Title</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.jobTitleName !== null ? profileDetail.jobTitleName : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Reports To</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.reportingPersonFirstName !== null ? profileDetail.reportingPersonFirstName + " " + profileDetail.reportingPersonLastName : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Current Gross[Month]</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.ctc !== null ? profileDetail.ctc : "-"}</TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </Grid>
                        <Grid item xs={6}>
                            <h2 className="pmp-headings">Reporting Manager / Appraiser</h2>
                            <Table className="score-table argus-table left-table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.reportingPersonFirstName !== null ? profileDetail.reportingPersonLastName !== null ? profileDetail.reportingPersonFirstName + " " + profileDetail.reportingPersonLastName : profileDetail.reportingPersonFirstName : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Emp ID</TableCell>

                                        <TableCell>{profileDetail !== null && profileDetail.reportingPersonEmpCode !== null ? profileDetail.reportingPersonEmpCode : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Department / Team Name</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.reportingPersonDepartmentName !== null ? profileDetail.reportingPersonTeam !== null ? profileDetail.reportingPersonDepartmentName + "/" + profileDetail.reportingPersonTeam : "-" : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Job Title</TableCell>
                                        <TableCell>{profileDetail !== null && profileDetail.reportingPersonJobTitle !== null ? profileDetail.reportingPersonJobTitle : "-"}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                    <p className='highlight-txt'>Please complete this section before meeting with your manager for your discussion (please note this will also be read by company management).</p>
                    <ul className='highlight-list'><li><DoneIcon className="tick-icon" /><span>Please provide any general insight about your working and learning experience over the last six months? There is no format for this response - whatever you believe is important or valuable to mention. Please mention any OKRs you were involved in, any training you participated in and any other projects or performance-related activities you feel are worth mentioning.</span>
                    </li></ul>
                    <TextareaAutosize className="insights" placeholder="Fill details here" value={insights} onChange={handleInsightsChange} minRows={5} readOnly={loggedUserId !== null && profileDetail !== null && profileDetail.id !== undefined && loggedUserId !== profileDetail.id} />
                    <span>{insightsError ? "Please fill out this field" : ""}</span>
                    {isCompleted ? "" : loggedUserId === reportingPersonId || loggedUserId === parseInt(profileDetail && profileDetail.reviewerManagerId) ? "" :
                        empLoader === true ?
                            <CircularProgress sx={{ float: "right" }} /> :
                            <Button className="theme-btn save-btn" sx={{ marginTop: "20px" }} disabled={isEnableInsightBtn} type="submit" variant="contained" onClick={handleInsightsSubmit}>Save</Button>}
                    {/* <Button type="reset" variant="outlined" onClick>Cancel</Button> */}
                </Card>
                {/* </Container> */}
            </div>
            {isOpenConfirmPopup ? <ReviewForm toggleConfirmPopup={toggleConfirmPopup} open={isOpenConfirmPopup} formId={id} scoreList={scorelist} /> : ""}
            {isOpenCommentPopup ? <ViewComments toggleCommentsPopup={toggleCommentsPopup} open={isOpenCommentPopup} commentList={commentList} /> : ""}
            <div className='note'>
                {/* <Container fixed> */}
                <Card className='part-one variable-pay no-overflow'>
                    <header className="sheader">
                        <h2>Part 1 – OKRs / Goals<div>Score: {avg_OkrScore}</div></h2>
                    </header>
                    <p className="highlight-txt">This section accounts for <b>40%</b> of the overall score.</p>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Table className='okr-table pmp-okr-table'>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: "white !important" }}>
                                        <TableCell colSpan={3} style={{ backgroundColor: "white !important" }} className="okr-tablehead" >OKR Score Card</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead sx={{ backgroundColor: "#f3f3f3" }}>
                                    <TableRow>
                                        <TableCell className="okr-tablehead" sx={{ color: "#fff !important" }}>KR Score</TableCell>
                                        <TableCell className="okr-tablehead">%</TableCell>
                                        <TableCell className="okr-tablehead">OKR Notes</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell className='bg-success'>10</TableCell>
                                        <TableCell>100%</TableCell>
                                        <TableCell className='text-start'>Achieved desired outcome - Excellent</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-success'>9</TableCell>
                                        <TableCell>90%</TableCell>
                                        <TableCell rowSpan={2} className='text-start'>Very good progress and achieved goals despite obstacles</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-success'>8</TableCell>
                                        <TableCell>80%</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-success'>7</TableCell>
                                        <TableCell>70%</TableCell>
                                        <TableCell rowSpan={2} className='text-start'>Good progress - but did not fully reach goals</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-warning'>6</TableCell>
                                        <TableCell>60%</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-warning'>5</TableCell>
                                        <TableCell>50%</TableCell>
                                        <TableCell rowSpan={2} className='text-start'>Progress seen, but goals not achieved due to challenges</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-warning'>4</TableCell>
                                        <TableCell>40%</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-danger'>3</TableCell>
                                        <TableCell>30%</TableCell>
                                        <TableCell rowSpan={3} className='text-start'>Failed to make reasonable progress</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-danger'>2</TableCell>
                                        <TableCell>20%</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='bg-danger'>1</TableCell>
                                        <TableCell>10%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                    <p className='highlight-txt'>The Reporting Manager to discuss and present OKRs during this phase of the meeting. The purpose is to generate 1 or more OKRs that the employee is directly involved in for the next 6 month period:</p>
                    {okrList.length !== 0 ? <Table className="score-table argus-table left-table">
                        <TableHead>
                            <TableCell></TableCell>
                            <TableCell>OKR Details</TableCell>
                            <TableCell>Score</TableCell>
                            <TableCell>Remarks</TableCell>
                        </TableHead>
                        <TableBody>
                            {okrList.length !== 0 && okrList.map((okr, index) => (<TableRow>
                                <TableCell>OKR {index + 1}</TableCell>
                                <TableCell align="right" className="okr-pmp">
                                    <span><Link to={`/viewokr/${okr.okrId}`} target="_blank" className="kr-head pmp-okr-head">{`(#${okr.okrId})` + " " + okr.title}<OpenInNewIcon className="open-icons" /></Link></span>
                                    <span>Due Date:{TimeConversion(okr.dueDate, 0)}</span>
                                    <span>Completion Date: {TimeConversion(okr.completionDate, 0)}</span>
                                    <span>Status :{okr.statusName !== null ? okr.statusName : "-"}</span>
                                    <span>No of Comments : {okr.reviewCommentsCount !== null && okr.reviewCommentsCount !== 0 ? <Button className="theme-btn" sx={{ float: "none", height: "auto !important", padding: "5px !important" }} onClick={() => toggleCommentsPopup(1, okr.okrId)}>{okr.reviewCommentsCount}</Button> : "-"}</span>
                                </TableCell>
                                <TableCell>{!isCompleted && loggedUserId === reportingPersonId ? <Select isDisabled={parseInt(formStatusId) === 5} menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={scores} name="score" onChange={(value, action) => handleChangeOKR(value, okr, action)} defaultValue={okr.score !== null ? scores.filter(score => parseInt(score.value) === okr.score) : ""} /> : okr.score !== null ? okr.score : "-"}</TableCell>
                                <TableCell>{!isCompleted && loggedUserId === reportingPersonId ? <TextField disabled={parseInt(formStatusId) === 5} style={{ backgroundColor: "white" }} fullWidth name="comment" placeholder="Remarks" onChange={(event) => handleChangeOKR(event, okr)} defaultValue={okr.remarks !== null ? okr.remarks : ""} /> : okr.remarks !== null ? okr.remarks : "-"}</TableCell>
                            </TableRow>))}
                        </TableBody>
                    </Table> : <Alert severity="error">Not participated in any OKRs in this period</Alert>}

                    <p className='mt-3'>More OKRs can be  added/agreed during the next 6 months and discussed at the next Performance Discussion</p>

                    {isCompleted ? "" : (loggedUserId === reportingPersonId && okrList.length !== 0 && parseInt(formStatusId) !== 5) ?
                        okrLoader ?
                            <CircularProgress fontSize="small" sx={{ float: "right" }} /> :
                            <Button type="submit" className="theme-btn" variant="contained" onClick={handleOKRFeedback}>Save</Button> : ""}
                </Card >
                {/* </Container > */}
            </div >
            {/* <br />
            <div> */}
            <div className='note'>
                {/* <Container fixed> */}
                <Card className="variable-pay no-overflow">
                    <header className="sheader">
                        <h2 className="pmp-headings">Part 2 – Performance and Use of VOICE<div>Score: {avg_VoiceScore}</div></h2>
                    </header>
                    <p className="pmp-para">This section accounts for <b>40%</b> of the overall score.</p>
                    <p className='pmp-para'>For explanation, please refer to the document: <b><a href={Voice} download="Aggregate Intelligence: The VOICE Value System">Aggregate Intelligence: The VOICE Value System</a></b></p>
                    <p className="pmp-para">In the Performance Discussion in December 2022 (and every six months thereafter), the Team Member will be scored on their “Use of VOICE”. The VOICE Value System covers five main values as listed below. The scoring is shown below and will be introduced in the December meeting.</p>

                    <Stack sx={{ width: '100%', marginBottom: "20px" }} spacing={2}>
                        <Alert severity="info">Score: 10 = Perfect |8-9 = Excellent | 7 = Good |6 = Satisfactory | 5 = Average | 4 And Below = Poor</Alert>
                    </Stack>


                    <Table className="score-table left-table">
                        <TableHead className="dark-head">
                            <TableCell></TableCell>
                            <TableCell>Skills or Qualities of Team Member</TableCell>
                            <TableCell>Questions</TableCell>
                            <TableCell>Score</TableCell>
                            <TableCell>Remarks</TableCell>
                        </TableHead>
                        <TableBody className="pmp-table-body">
                            {voiceQuestList.map((voice, index) => {
                                return (
                                    <>
                                        {voice && voice.questions.map((questions, qindex) => {
                                            return (
                                                <TableRow className="okr-que-row" style={{ backgroundColor: index % 2 === 0 ? "#f1f1f1" : "white" }}>
                                                    {qindex === 0 ?
                                                        <>
                                                            <TableCell className="pmp-index-one" rowSpan={voice.questions.length}>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell className="pmp-voice-type" rowSpan={voice.questions.length}>
                                                                <strong> {voice.voiceType} </strong>
                                                            </TableCell>
                                                        </> : ""
                                                    }
                                                    <TableCell className="pmp-okr-que">{questions.question}</TableCell>
                                                    <TableCell>{!isCompleted && loggedUserId == parseInt(reportingPersonId) ? <Select isDisabled={parseInt(formStatusId) === 5} menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={scores} name="score" placeholder="Select" onChange={(value, action) => handleChangeVoice(value, questions, action, voice.voiceType)} defaultValue={questions.score !== null ? scores.filter(score => parseInt(score.value) === voiceQuestList.filter(voices => voices.voiceType == voice.voiceType)[0].questions.filter(que => que.id == questions.id)[0].score) : ""} /> : questions.score !== null ? questions.score : "-"}</TableCell>
                                                    <TableCell>{!isCompleted && loggedUserId == parseInt(reportingPersonId) ? <TextField disabled={parseInt(formStatusId) === 5} style={{ backgroundColor: "white" }} name="comment" placeholder="Remarks" onChange={(event) => handleChangeVoice(event, questions)} defaultValue={questions.comment !== null ? voiceQuestList.filter(voices => voices.voiceType == voice.voiceType)[0].questions.filter(que => que.id == questions.id)[0].comment : ""} /> : questions.comment !== null ? questions.comment : "-"}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </>
                                )
                            })}

                        </TableBody>
                    </Table>
                    <p>The aggregate score of the 5 values will then translate to a score out of 40% for this portion of the overall Performance Score.</p>

                    {isCompleted ? "" : loggedUserId === reportingPersonId ?
                        voiceLoader ?
                            <CircularProgress fontSize="small" sx={{ float: "right" }} /> :
                            <Button type="submit" className="theme-btn" disabled={parseInt(formStatusId) === 5} variant="contained" onClick={SaveVoiceFeedback}>Save</Button> : ""}
                </Card>
                {/* </Container> */}
            </div>
            <div className='note'>
                {/* <Container fixed> */}
                <Card className='part-three variable-pay no-overflow'>
                    <header className="sheader">
                        <h2>Part 3 – Training and Development<div>Score: {avg_TrainingScore}</div></h2>
                    </header>
                    <p className="highlight-txt">This section accounts for <b>20%</b> of the overall score.</p>
                    <p>The Team Member and Reporting Manager should suggest training ideas here for the team member to participate in over the next 6 months. More can be added at a later date as more courses become available. These will be reviewed by the Training Management team and a list of training options will be published by the end of July and communicated to the Team Member.</p>

                    <h3>Internal Training</h3>
                    {trainingList && trainingList.trainings !== undefined && trainingList.trainings.length !== 0 ? <Table className="score-table argus-table left-table">
                        <TableHead>
                            <TableCell></TableCell>
                            <TableCell>Training Details</TableCell>
                            <TableCell>Score</TableCell>
                            <TableCell>Remarks</TableCell>
                        </TableHead>

                        <TableBody>
                            {trainingList && trainingList.trainings !== undefined && trainingList.trainings.length !== 0 ? trainingList.trainings.map((training, index) => (
                                <TableRow>
                                    {/* {training.trainingScore !== null ? console.log(scores.filter(score => score.value == training.trainingScore)) : ""} */}
                                    <TableCell>Training {index + 1}</TableCell>
                                    <TableCell align="left" className="okr-pmp">
                                        <strong className="pmpform-training-title">{training.title !== null ? training.title : "-"}</strong>
                                        <span>Start Date : {TimeConversion(training.startDate, 0)}</span><br />
                                        <span>End Date: {TimeConversion(training.endDate, 0)}</span><br />
                                        <span>Level : {training.levelName !== null ? training.levelName : "-"}</span><br />
                                        <span>Status : {training.title !== null ? training.trainingStatusName : "-"}</span><br />
                                        <span>Trainer Comments : {training.trainerComment !== null ? training.trainerComment : "-"}</span>
                                    </TableCell>
                                    <TableCell>{!isCompleted && loggedUserId === reportingPersonId ? <Select isDisabled={parseInt(formStatusId) === 5} menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={scores} name="score" onChange={(value, action) => handleChangeTraining(value, training, action, "i")} defaultValue={training.trainingScore !== null ? scores.filter(score => parseInt(score.value) === parseInt(training.trainingScore)) : ""} /> : training.trainingScore !== null ? training.trainingScore : "-"}</TableCell>
                                    <TableCell>{!isCompleted && loggedUserId === reportingPersonId ? <TextField disabled={parseInt(formStatusId) === 5} style={{ backgroundColor: "white" }} fullWidth name="comment" placeholder="Remarks" onChange={(event) => handleChangeTraining(event, training, undefined, "i")} defaultValue={training.scoreComment !== null ? training.scoreComment : ""} /> : training.scoreComment !== null ? training.scoreComment : "-"}</TableCell>
                                </TableRow>)) : ""}
                        </TableBody>
                    </Table> : <Alert severity="error">Not attended  any Trainings in this period</Alert>}
                    <br />

                    <h3>External Training</h3>
                    {trainingList && trainingList.externalTrainings !== undefined && trainingList.externalTrainings.length !== 0 ? <Table className="score-table argus-table left-table">
                        <TableHead>
                            <TableCell></TableCell>
                            <TableCell>Training Details</TableCell>
                            <TableCell>Score</TableCell>
                            <TableCell>Remarks</TableCell>
                        </TableHead>

                        <TableBody>
                            {trainingList && trainingList.externalTrainings !== undefined && trainingList.externalTrainings.length !== 0 ? trainingList.externalTrainings.map((training, index) => (
                                <TableRow>
                                    {/* {training.trainingScore !== null ? console.log(scores.filter(score => score.value == training.trainingScore)) : ""} */}
                                    <TableCell>Training {index + 1}</TableCell>
                                    <TableCell align="left" className="okr-pmp">
                                        <strong className="pmpform-training-title">{training.title !== null ? training.title : "-"}</strong>
                                        <span>Start Date : {TimeConversion(training.startDate, 0)}</span><br />
                                        <span>End Date: {TimeConversion(training.endDate, 0)}</span><br />
                                        <span>Level : {training.levelName !== null ? training.levelName : "-"}</span><br />
                                        <span>Status : {training.title !== null ? training.trainingStatusName : "-"}</span><br />
                                        <span>Trainer Comments : {training.trainerComment !== null ? training.trainerComment : "-"}</span>
                                    </TableCell>
                                    <TableCell>{!isCompleted && loggedUserId === reportingPersonId ? <Select isDisabled={parseInt(formStatusId) === 5} menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={scores} name="score" onChange={(value, action) => handleChangeTraining(value, training, action, "x")} defaultValue={training.trainingScore !== null ? scores.filter(score => parseInt(score.value) === parseInt(training.trainingScore)) : ""} /> : training.trainingScore !== null ? training.trainingScore : "-"}</TableCell>
                                    <TableCell>{!isCompleted && loggedUserId === reportingPersonId ? <TextField disabled={parseInt(formStatusId) === 5} style={{ backgroundColor: "white" }} fullWidth name="comment" placeholder="Remarks" onChange={(event) => handleChangeTraining(event, training, undefined, "x")} defaultValue={training.scoreComment !== null ? training.scoreComment : ""} /> : training.scoreComment !== null ? training.scoreComment : "-"}</TableCell>
                                </TableRow>)) : ""}
                        </TableBody>
                    </Table> : <Alert severity="error">Not attended  any Trainings in this period</Alert>}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ marginTop: "20px" }}>
                            {isCompleted ? "" : ((trainingList.trainings !== undefined && trainingList.trainings.length !== 0) || (trainingList.externalTrainings !== undefined && trainingList.externalTrainings.length !== 0)) && loggedUserId === reportingPersonId && parseInt(formStatusId) !== 5 ?
                                trainingLoader ?
                                    <CircularProgress fontSize="small" sx={{ float: "right" }} /> :
                                    <Button type="submit" className="theme-btn" sx={{ marginLeft: "10px" }} variant="contained" onClick={SaveTrainingFeedback}>Save</Button> : ""}
                        </Grid>
                        <Grid item xs={12}>
                            {isCompleted ? "" : loggedUserId === reportingPersonId ?
                                submitLoader ?
                                    <CircularProgress fontSize="small" sx={{ float: "right" }} /> :
                                    <Button type="submit" className="theme-btn" sx={{ marginLeft: "10px" }} variant="contained" disabled={parseInt(formStatusId) === 5} onClick={handleSubmit}>Submit</Button> : ""}
                            &nbsp;<Button onClick={handleClose} className="theme-btn cancel-btn" variant="contained">Close</Button>
                            <br />
                            {parseInt(loggedUserId) === parseInt(profileDetail && profileDetail.reviewerManagerId) && parseInt(formStatusId) === 3?
                                <Button sx={{ marginLeft: "10px" }} onClick={handleClickOpenDialog} className="theme-btn cancel-btn apprval-form" disabled={parseInt(loggedUserId) !== parseInt(profileDetail && profileDetail.reviewerManagerId)}>Approve </Button>

                                : ""}
                        </Grid>
                        {/* {parseInt(loggedUserId) === parseInt(profileDetail && profileDetail.reviewerManagerId) && parseInt(formStatusId) === 3 ?
                            <Grid item xs={12}>
                                <Button sx={{ marginLeft: "10px" }} onClick={handleClickOpenDialog} className="theme-btn apprval" disabled={parseInt(loggedUserId) !== parseInt(profileDetail && profileDetail.reviewerManagerId)}>Approve</Button>

                            </Grid> : ""} */}
                    </Grid>
                </Card>
                {/* </Container> */}
            </div>
            <CustomizedSnackbar />



        </div >
    )
}

export default Form;